import React, { useState } from "react";
import { Link, NavLink, withRouter, useHistory } from "react-router-dom";
import { useQuery } from 'react-query';
import Search from "./Search";
import Login from "../Login/Login";
import CountDownBanner from "./CountDownBanner";

function HeaderBar(props) {
  const [OpenMobileMenu, setOpenMobileMenu] = useState(false);
  const { isError, data, error } = useQuery(['menuData'], () => fetchMenuData(), {    
    enabled: !!props.token, // query inattiva finchè il token non è valido (non necessario)
    staleTime: 60 * 60 * 24 * 1000, // cache stale time impostato a 24 ore
  });
  const history = useHistory();
  const [OpenMobileCategory, setOpenMobileCategory] = useState(() => {
    const initialState = initOpenMobileCategory(data);
    return initialState;
  });
 
  async function fetchMenuData() {
    try {
      var myHeaders = new Headers();
      //console.log("fetchMenuData() - with token: " + Token.access_token);
      myHeaders.append("Authorization", "Bearer " + props.token.access_token);
      myHeaders.append("Accept", "application/json");

      var formdata = new FormData();

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };
      const response = await fetch(
        "https://ws.mediatoys.it/menu/ViewMenu",
        requestOptions
      );
      if (!response.ok) {
        if (response.status === 401) {
          // check error message???
          if (props.cfg.debug === true) 
            console.log("TOKEN UPDATE!");
          props.tokenUpdate();
        }
        throw new Error("Network error " + response.status);
      }
      const payload = await response.json();
      if (props.cfg.debug === true)  {
        console.log("fetchMenuData() OK");
        console.log(payload);
      }
      let now = Date.now();
      if (payload.timer_spedizioni) {
        payload.timer_spedizioni.local = {
          timestamp: now,  // NOTA: in msec, mentre unix_time sono in sec
          delta: ((now/1000) - payload.timer_spedizioni.now.unix_time), // differenza in secs tra i due "now"
        }
      }
      setOpenMobileCategory(initOpenMobileCategory(payload));
      return payload;
    } catch (error) {
      console.log(error.message);
      //setNetError(error.message);
      throw new Error(error.message);
    }
  }

  function topBanner() {
    if (!data || !data.banner)
      return null;
    if (data.banner.length > 0) {
      let idx = Math.floor(Math.random() * data.banner.length);
      let banner = data.banner[idx];
      return (
      <div className="top-banner" style={{backgroundColor: banner.bgColor}}>
	      <p style={{color: banner.textColor}}>
          {banner.text}
        </p>
      </div>) 
    } else 
      return null;
  }
/*
  function calcTimeLeft() {
    if (!data || !data.timer_spedizioni)
      return null;

  }

  function timerBanner() {
    if (!data || !data.timer_spedizioni)
      return null;
    if (data.timer_spedizioni) {
      const days = ["Domenica", "Lunedì", "Martedì", "Mercoledì", "Giovedì", "Venerdì", "Sabato"];
      const months = ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"];
      let delDate = new Date(data.timer_spedizioni.time_consegna.unix_time * 1000);
      let delMonthDay = delDate.getDate();
      let delMonth = delDate.getMonth();
      let delDay = delDate.getDay();
      
      return (
      <div className="top-banner" >
	      <p>
          Vuoi il tuo ordine {days[delDay]} {delMonthDay} {months[delMonth]}? * Ordina entro: <span>{}</span>
        </p>
      </div>) 
    } else 
      return null;
  }
*/
  
  // NOTA: il funzionamento si basa implicitamente sulla struttura degli url
  // l'array slugs sarà così composto: 
  // - caso A) ["", "articoli"]                                                         (url cataogo)
  // - caso B) ["", "articoli", <slug sottocategoria>, <id sottocategoria>]             (url categoria)
  // - caso C) ["", "articoli", <slug sottocategoria>, <slug prodotto>, <id prodotto>]  (url prodotto)
  function initOpenMobileCategory(menuData) {
    if (!menuData)
      return 0;
    const slugs = history.location.pathname.split("/");  
    //console.log(slugs);
    if (slugs.length <= 2) 
      return 0;
    if (slugs[1] === props.cfg.catalogSlug) {
      let res = menuData.menu.find((el) => {
        if (el.type !== "Category" || !el.SubCategory)
          return false;
        let r = el.SubCategory.find((sel) => sel.slug === slugs[2]);
        //console.log("subc:" + el.nome);
        //console.log(r);
        return r? true : false;
      });
      //console.log(res);
      //if (res.length !== 1)
      if (res) {
       //return res[0].id;
        //console.log("value = "+res.id);
        return res.id;
      } else
        return 0;
     } else 
      return 0;  
  }


  //console.log(slugs); // "", "articoli", "burago", "5"
  //console.log("OpenMobileMenu "+OpenMobileMenu);
  //console.log(props.userData);
  //console.log(history.location);
  //console.log(data);
  //console.log("OpenMobileCategory: " + OpenMobileCategory);
  
  if ((!data) || (!data.menu)) {
    //console.log(props);
    if (isError && error !== null) 
      return <p>{error.message}</p>;
    else 
      return null;
  } 
  return (
    <>
      {topBanner()}
      <header className="header_01">
        <div className="logo_01">
          <Link to="/home">
            <img src="/images/logo_header_on.png" alt="Home" />
          </Link>
        </div>

        <div className="menu_01">
          <nav className="nav_01">
            <ul>
              {data.menu.map((val) => {
                //console.log("--- " + val.nome + " - " + val.type);
                if (val.type === "Static") {
                  return (
                    <li key={"ms_" + val.id}>
                      <NavLink to={"/" + val.slug}>
                        <p>{val.nome.toUpperCase()}</p>
                      </NavLink>
                    </li>
                  );
                } else {
                  return (
                    <li key={"mc_" + val.id}>
                      <p>{val.nome.toUpperCase()}</p>
                      <div className="sottomenu">
                        <ul>
                          {val.SubCategory.map((el) => {
                            return (
                              <li key={"mcs_" + el.id}>
                                <NavLink
                                  to={"/"+props.cfg.catalogSlug+"/" + el.slug + "/" + el.id}
                                >
                                  <p>{el.nome.toUpperCase()}</p>
                                </NavLink>
                              </li>
                            );
                          })}
                        </ul>
                      </div>
                    </li>
                  );
                }
              })}
            </ul>
          </nav>
        </div>

        <div className="hm_mobile" onClick={() => setOpenMobileMenu(true)}>
          <img src="/images/hm.svg" alt="Home" />
        </div>

        {OpenMobileMenu === true ? (
          <>
            <div className="menu_mobile">
              <div
                className="x_mobile"
                onClick={() => setOpenMobileMenu(false)}
              >
                <img src="/images/x_hm.svg" alt="Home" />
              </div>
              <nav className="nav_mobile">
                <ul>
                  {data.menu.map((val) => {
                    if (val.type === "Static") {
                      return (
                        <li key={"mms_" + val.id}>
                          <NavLink
                            to={"/" + val.slug}
                            onClick={() => setOpenMobileMenu(false)}
                          >
                            <p>{val.nome.toUpperCase()}</p>
                          </NavLink>
                        </li>
                      );
                    } else {
                      // categories
                      return (
                        <li key={"mmc_" + val.id}>
                          <p
                            onClick={() =>
                              OpenMobileCategory === val.id
                                ? setOpenMobileCategory(0)
                                : setOpenMobileCategory(val.id)
                            }
                          >
                            {val.nome.toUpperCase()}
                          </p>
                          {OpenMobileCategory === val.id ? (
                            <img
                              src={"/images/arrow_hm_up.svg"}
                              className="filtri-toggle"
                              onClick={(e) => setOpenMobileCategory(0)}
                              title="chiudi"
                              alt="chiudi"
                            />
                          ) : (
                            <img
                              src={"/images/arrow_hm_down.svg"}
                              className="filtri-toggle"
                              onClick={(e) => setOpenMobileCategory(val.id)}
                              title="espandi"
                              alt="espandi"
                            />
                          )}
                          {OpenMobileCategory === val.id ? (
                            <div className="sottomenu_mobile">
                              <ul>
                                {val.SubCategory.map((el) => {
                                  return (
                                    <li key={"mmcs_" + el.id}>
                                      <NavLink
                                        to={
                                          "/"+props.cfg.catalogSlug+"/" + el.slug + "/" + el.id
                                        }
                                        onClick={() => setOpenMobileMenu(false)}
                                      >
                                        <p>{el.nome.toUpperCase()}</p>
                                      </NavLink>
                                    </li>
                                  );
                                })}
                              </ul>
                            </div>
                          ) : null}
                        </li>
                      );
                    }
                  })}
                </ul>
              </nav>
              <div onClick={() => setOpenMobileMenu(false)}>
                <Login userData={props.userData} textToRight={true} />
              </div>
            </div>

            <div className="modal_hm"></div>
          </>
        ) : null}

        <div className="logo_mobile">
          <Link to="/home">
            <img src="/images/logo_mobile.png" alt="Home" />
          </Link>
        </div>

        <div className="header_02">
          <Login userData={props.userData} />
          <div className="ico_preferiti">
            <Link to="/profilo/preferiti">
              <img src="/images/preferiti_on.svg" alt="Preferiti" />
            </Link>
          </div>
          <div className="ricerca">
            <div className="ico_lente">
              <img src="/images/lente_on.svg" alt="Cerca" />
              <Search cfg={props.cfg} />
            </div>
          </div>
          <div className="ico_carrello">
            <Link to="/carrello">
              <div className="carrello_numero">
                <p>{props.qty > 0 ? props.qty : null}</p>
              </div>
              <img src="/images/carrello_on.svg" alt="Carrello" />
              &nbsp;
            </Link>
          </div>
        </div>
      </header>

      <CountDownBanner 
        timer_spedizioni={data.timer_spedizioni} 
      />

      <div
        className="modal"
        id="AwMobileMenuBg"        
      ></div>
    </>
  );
}

export default withRouter(HeaderBar);
